export default "__VITE_ASSET__BnM273RS__"